module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-sub-schedule",
    attrs: {
      "data-aos": "fade-up",
      "data-aos-once": "true"
    }
  }, [_c('page-subtab', {
    attrs: {
      "title-infos": _vm.dates,
      "selected-index": _vm.dateIndex
    },
    on: {
      "title-changed": _vm.onDateChanged
    }
  }), _vm._v(" "), (_vm.currentDate && _vm.currentDateScheduleLoaded && _vm.items[_vm.currentDate]) ? _c('div-container', [_c('div', {
    staticClass: "columns is-gapless is-centered is-vcentered is-multiline is-flex-mobile"
  }, [_c('div', {
    staticClass: "column is-11 has-text-left content"
  }, _vm._l((_vm.items[_vm.currentDate]), function(item) {
    return _c('div', {
      staticClass: "columns is-gapless is-centered is-multiline content-row"
    }, [_c('div', {
      staticClass: "column is-4 has-text-left content-date"
    }, [_c('h2', [_c('p', [_vm._v("\n              " + _vm._s(item.full_date) + "\n            ")])])]), _vm._v(" "), _c('div', {
      staticClass: "column is-8 has-text-left content-description"
    }, [_c('h2', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(item.description)
      }
    })])])])
  }), 0)])]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a4088be2","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ScheduleSubSection.vue
// module id = 931
// module chunks = 1